export default __webpack_public_path__ + "static/Theinhardt-Medium-subset-14cd1a06bcd86eaf22035cbde899606f.woff";